<template>
  <DeVideo />
</template>

<script>

import DeVideo from '@/components/canvas/custom-component/DeVideo'
export default {
  name: 'Video',
  components: { DeVideo },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
